// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608241504/js/" + chunkId + "." + {"44":"827807e0","225":"98f51c96","481":"f9bfbf4c","486":"faaaa8bd","770":"43d22ba5"}[chunkId] + ".0.6330728441939778.chunk.js";
};